import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';

// Production retains its clean-workshop values when no build configuration is
// supplied. The isolated acceptance build receives its own verified identity
// at compile time; the browser must still fail closed on any mismatch.
const EXPECTED_PROJECT_REF = process.env.REACT_APP_WMS_EXPECTED_SUPABASE_PROJECT_REF || 'kbnimkkjgasxjpehudpg';
const EXPECTED_DATA_EPOCH = process.env.REACT_APP_WMS_EXPECTED_DATA_EPOCH || 'workshop-clean-2026-09-18-v1';

export default function RuntimeIdentityGate({ children }) {
    const [state, setState] = React.useState({ status: 'checking', detail: '' });
    React.useEffect(() => {
        let cancelled = false;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        fetch('/api/runtime-identity', { cache: 'no-store', credentials: 'include', signal: controller.signal })
            .then(async (res) => {
                if (!res.ok)
                    throw new Error(`runtime_identity_http_${res.status}`);
                const data = await res.json();
                const projectRef = String(data?.project_ref || '');
                const dataEpoch = String(data?.data_epoch || '');
                if (projectRef !== EXPECTED_PROJECT_REF || dataEpoch !== EXPECTED_DATA_EPOCH)
                    throw new Error('runtime_identity_mismatch');
                if (!cancelled)
                    setState({ status: 'ready', detail: '' });
            })
            .catch((err) => {
                if (!cancelled)
                    setState({ status: 'blocked', detail: err?.message || 'runtime_identity_unavailable' });
            })
            .finally(() => clearTimeout(timeout));
        return () => {
            cancelled = true;
            clearTimeout(timeout);
            controller.abort();
        };
    }, []);
    if (state.status === 'ready')
        return children;
    if (state.status === 'checking')
        return _jsx("div", { dir: "rtl", className: "min-h-screen flex items-center justify-center p-6 bg-slate-950 text-white", children: _jsx("div", { className: "rounded-2xl border border-white/10 bg-white/5 px-5 py-4 text-sm", children: "جاري التحقق من مصدر بيانات WMS المعتمد…" }) });
    return _jsx("div", { dir: "rtl", className: "min-h-screen flex items-center justify-center p-6 bg-slate-950 text-white", children: _jsxs("div", { className: "max-w-lg rounded-2xl border border-amber-400/30 bg-amber-500/10 p-5", children: [_jsx("h1", { className: "text-lg font-extrabold", children: "تم إيقاف الاتصال لحماية نقطة البداية النظيفة" }), _jsx("p", { className: "mt-2 text-sm text-slate-200", children: "لن يعرض WMS أو يكتب أي بيانات حتى يتم ربط الباك إند بقاعدة workshop المعتمدة وإثبات هوية المصدر." }), _jsx("p", { className: "mt-3 text-xs text-slate-400", children: state.detail })] }) });
}
